import React from 'react';
import { Link } from 'react-router-dom';
import lawyer1 from "../../images/homepage/lawyer 1.JPG";
import lawyer2 from "../../images/homepage/lawyer 2.JPG";
import lawyer3 from "../../images/homepage/lawyer 3.JPG";
import lawyer4 from "../../images/homepage/lawyer 4.JPG";
import law from "../../images/homepage/law.png";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import BgImage from "../../images/practiceArea/agreement.jpeg";

const About = () => {
  const lawyers = [
    {
      name: 'Jonson Leo',
      specialization: 'Civil Lawyer',
      image: lawyer1,
      social: [
        { link: "#", icon: <FaFacebookF /> },
        { link: "#", icon: <FaTwitter /> },
        { link: "#", icon: <FaLinkedinIn /> },
        { link: "#", icon: <FaInstagram /> },
      ]
    },
    {
      name: 'Mostafa Amin',
      specialization: 'Family Lawyer',
      image: lawyer2,
      social: [
        { link: "#", icon: <FaFacebookF /> },
        { link: "#", icon: <FaTwitter /> },
        { link: "#", icon: <FaLinkedinIn /> },
        { link: "#", icon: <FaInstagram /> },
      ]
    },
    {
      name: 'Neobir Fro',
      specialization: 'Business Lawyer',
      image: lawyer3,
      social: [
        { link: "#", icon: <FaFacebookF /> },
        { link: "#", icon: <FaTwitter /> },
        { link: "#", icon: <FaLinkedinIn /> },
        { link: "#", icon: <FaInstagram /> },
      ]
    },
    {
      name: 'Natalie Penelope',
      specialization: 'Criminal Lawyer',
      image: lawyer4,
      social: [
        { link: "#", icon: <FaFacebookF /> },
        { link: "#", icon: <FaTwitter /> },
        { link: "#", icon: <FaLinkedinIn /> },
        { link: "#", icon: <FaInstagram /> },
      ]
    },
  ];

  const LawyerCard = ({ lawyer }) => (
    <div className="relative bg-white shadow-md hover:shadow-lg transition-shadow duration-300">
      <img src={lawyer.image} alt={lawyer.name} className="w-full h-72 object-cover" />
      <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-60 text-white p-4">
        <h3 className="text-[13px] font-semibold">{lawyer.name}</h3>
        <p className="text-sm">{lawyer.specialization}</p>
        <div className="absolute top-2 right-2 flex space-x-2">
          {lawyer.social.map((link, index) => (
            <a href={link.link} key={index} className="text-white">
              {link.icon}
            </a>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className="bg-gray-100 min-h-screen">
      {/* Header Section */}
      <section className="relative h-[400px] md:h-[450px] flex items-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(5, 33, 55, 0.9), rgba(5, 33, 55, 0.9)), url(${BgImage})`,
        }}>
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl font-bold text-white">About LawBeron Legals</h1>
          <p className="text-lg md:text-l text-white mb-6">
            Excellence in Legal Representation
          </p>
          <div className="mt-8 flex justify-center gap-4">
            <Link to="/book" className="bg-transparent border-2 border-white hover:bg-white hover:text-blue-900 text-white font-semibold py-2 px-4 rounded-xl shadow-lg transition duration-300">
              Speak with a consultant
            </Link>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="max-w-5xl mx-auto py-12 px-6">
        <h2 className="text-3xl font-semibold text-blue-900 text-center mb-6">
          Who We Are
        </h2>
        <p className="text-gray-700 text-lg leading-relaxed text-center">
          LawBeron Legals is a full-service law firm committed to delivering
          outstanding legal solutions. With a team of dedicated professionals,
          we specialize in corporate law, dispute resolution, real estate, and
          intellectual property. Our goal is to provide clients with expert
          guidance, ensuring their legal rights are protected.
        </p>
      </section>

      {/* Mission and Values */}
      <section className="bg-white py-12">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-10">
            <div>
              <h2 className="text-2xl font-bold text-blue-900 mb-3">Our Mission</h2>
              <p className="text-gray-700 leading-relaxed">
                At LawBeron Legals, our mission is to uphold justice, advocate
                for our clients, and provide top-tier legal representation. We
                aim to make legal processes seamless and efficient while
                ensuring the best possible outcomes.
              </p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-blue-900 mb-3">Our Values</h2>
              <ul className="list-disc text-gray-700 pl-5 space-y-2">
                <li><span className="font-semibold">Integrity:</span> We operate with honesty and fairness.</li>
                <li><span className="font-semibold">Excellence:</span> We provide superior legal services.</li>
                <li><span className="font-semibold">Client-Centered:</span> Your success is our priority.</li>
                <li><span className="font-semibold">Innovation:</span> We embrace modern legal strategies.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <div className="max-w-7xl mx-auto p-4">
        <div className="my-[3%]">
          <div className="md:w-[80%] flex gap-4 items-start">
            <div>
              <img src={law} className="md:w-[50px]" alt="the law" />
            </div>
            <div>
              <p className="text-[24px] font-[600]">Meet Our Lawyers</p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {lawyers.map((lawyer, index) => (
            <LawyerCard lawyer={lawyer} key={index} />
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <section className="bg-blue-900 text-white py-12 text-center">
        <h2 className="text-3xl font-semibold">Need Legal Assistance?</h2>
        <p className="mt-2 text-lg">
          Contact LawBeron Legals for expert legal representation.
        </p>
        <button className="mt-6 bg-white text-blue-900 px-6 py-3 font-semibold rounded-lg shadow-lg">
          <Link to="/book">Schedule a Consultation</Link>
        </button>
      </section>
    </div>
  )
}

export default About;
